/* VAILA · Selección VAILA del día (lunes a sábado, hora de Colombia) */
(function () {
  var root = document.querySelector('[data-vpd-root]');
  var pill = document.querySelector('[data-vpd-pill]');
  if (!root || !pill) return;

  var KEY = 'vaila_promo_dia';
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var ROLE = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || 'main';
  var TEST = ROLE !== 'main'; /* los parámetros de prueba solo funcionan en temas NO publicados */
  var q = new URLSearchParams(window.location.search);
  var card = root.querySelector('.vpd__card');
  var delay = (parseFloat(root.getAttribute('data-vpd-delay')) || 4) * 1000;
  var recover = root.getAttribute('data-vpd-recover') === 'true';
  var t0 = Date.now(), timer = null, armed = false, lastFocus = null;

  function bogota() {
    var dow, stamp;
    try {
      var o = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/Bogota', weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      dow = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[o.weekday];
      stamp = o.year + '-' + o.month + '-' + o.day;
    } catch (e) {
      var n = new Date(Date.now() - 5 * 3600000); /* Colombia = UTC-5, sin horario de verano */
      dow = n.getUTCDay();
      stamp = n.toISOString().slice(0, 10);
    }
    return { dow: dow, stamp: stamp };
  }

  var now = bogota();
  if (TEST && q.has('vpd_day')) now.dow = parseInt(q.get('vpd_day'), 10);
  if (TEST && q.get('vpd_reset') === '1') { try { sessionStorage.removeItem(KEY); } catch (e) {} }

  root.setAttribute('data-vpd-today', String(now.dow));
  var tpl = root.querySelector('template[data-vpd-day="' + now.dow + '"]');
  if (!tpl) return; /* domingo, día desactivado o presentación agotada: no se muestra nada */
  card.appendChild(tpl.content.cloneNode(true));

  function getState() {
    try {
      var s = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      return s && s.d === now.stamp ? s.s : null;
    } catch (e) { return null; }
  }
  function setState(s) { try { sessionStorage.setItem(KEY, JSON.stringify({ d: now.stamp, s: s })); } catch (e) {} }
  function showPill() { if (recover) pill.hidden = false; }

  function open() {
    disarm();
    lastFocus = document.activeElement;
    pill.hidden = true;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    if (getState() !== 'closed') setState('shown');
    var x = root.querySelector('.vpd__x');
    setTimeout(function () { try { x.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    setState('closed');
    showPill();
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  var evs = ['pointerdown', 'touchstart', 'keydown', 'wheel'];
  function autoOpen() {
    if (!armed || document.visibilityState !== 'visible') return;
    open();
  }
  function onInteract() { if (Date.now() - t0 >= 2500) autoOpen(); }
  function onScroll() { if ((window.pageYOffset || 0) > 40) onInteract(); }
  function onVis() { if (Date.now() - t0 >= delay) autoOpen(); }
  function disarm() {
    armed = false;
    clearTimeout(timer);
    evs.forEach(function (e) { window.removeEventListener(e, onInteract); });
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('visibilitychange', onVis);
  }

  root.querySelectorAll('[data-vpd-close]').forEach(function (el) { el.addEventListener('click', close); });
  pill.addEventListener('click', open);
  var cta = root.querySelector('[data-vpd-cta]');
  if (cta) cta.addEventListener('click', function () { setState('closed'); });
  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = [root.querySelector('.vpd__x'), cta].filter(Boolean);
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    }
  });

  var state = getState();
  if (state || DESIGN) showPill();
  if (!state && !DESIGN) {
    armed = true;
    timer = setTimeout(autoOpen, delay);
    evs.forEach(function (e) { window.addEventListener(e, onInteract, { passive: true }); });
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('visibilitychange', onVis);
  }
  root.setAttribute('data-vpd-ready', '1');
})();